import { motion } from "framer-motion";
import { useContext, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Context from "../context";

const Success = () => {
  const { fetchUserAddToCart } = useContext(Context);
  const isLoggedIn = !!useSelector((state) => state?.user?.user);

  useEffect(() => {
    // Clear guest cart if it exists
    localStorage.removeItem("guestCart");
    fetchUserAddToCart();
  }, [fetchUserAddToCart]);

  return (
    <div className="bg-surface-muted min-h-[85vh] flex items-center justify-center px-4 md:px-6 py-12">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white w-full max-w-lg rounded-[2.5rem] md:rounded-card shadow-premium p-8 md:p-12 text-center"
      >
        <div className="relative w-24 h-24 md:w-32 md:h-32 mx-auto mb-6 md:mb-8">
          <div className="absolute inset-0 bg-green-100 rounded-full animate-ping opacity-20" />
          <div className="relative flex items-center justify-center w-full h-full bg-green-50 rounded-full">
            <FaCheckCircle className="text-green-500 text-4xl md:text-5xl" />
          </div>
        </div>

        <h1 className="text-2xl md:text-3xl font-black text-primary mb-3 md:mb-4 tracking-tight">
          Payment Successful!
        </h1>
        <p className="text-sm md:text-base text-gray-500 font-medium mb-8 md:mb-12 max-w-xs mx-auto leading-relaxed">
          Thank you for your purchase. We've received your order and are getting
          it ready for shipment.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
          {isLoggedIn && (
            <Link
              to="/order"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary text-white text-sm font-black rounded-full hover:bg-accent transition-all shadow-xl shadow-primary/20 active:scale-95"
            >
              View My Orders
            </Link>
          )}
          <Link
            to="/"
            className="w-full sm:w-auto px-8 py-3.5 border-2 border-primary text-primary text-sm font-black rounded-full hover:bg-primary hover:text-white transition-all active:scale-95"
          >
            {isLoggedIn ? "Return Home" : "Continue Shopping"}
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default Success;
